import React, { useState, useEffect } from 'react'
import '../styles/basicLayout.css'
import back from "../assets/back.png";
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S } from "../utils/constants";
import {
  useParams,
  useHistory
} from "react-router-dom";
import { getRecipes, deleteRecipe } from "../api";
import EditRecipe from '../dialog/EditRecipe';

export const settings = {
  PRODUCT_TEMP: "PRODUCT_TEMP",
  GRILL_TEMP: "GRILL_TEMP",
  TIME: "TIME"
}



export default function Recipes() {
  let { category } = useParams();
  const history = useHistory();
  const [recipes, setRecipes] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [activeRecipe, setActiveRecipe] = useState({}) 

  const handleDelRecipe = (id) => {
    if (window.confirm("Do you really want to delete this recipe?")) {
      const resp = deleteRecipe({ id })
      setOpenDialog(false)
      if (resp?.code === 1) {
        alert(`Could not delete recipe, please try again later.`)
      }
      else {
        const newRecList = recipes.filter(recp => recp._id !== id)
        setRecipes(newRecList)
        alert(`Recipe deleted`)
      }
    }
  }

  const loadRecipes = async () => {
    const resp = await getRecipes({ category })
    if (resp?.code === 1) {

    }
    else {
      setRecipes(resp.data)
    }
  }

  useEffect(() => {

    loadRecipes()
  }, [])

  return (
    <>
      <EditRecipe 
        visible={openDialog} 
        handleClose={ () => setOpenDialog(false)} 
        recipe={activeRecipe}
        handleDeleteRecipe={(id) => handleDelRecipe(id)}
        handleEditRecipe={(id) => history.push(`/recipe/${id}`)}
      />
      <header>
        <div className="left">
          <img className="btn" width="80px" src={back} alt="" onClick={() => history.goBack()} />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center">
          <h2>{category} - Recipes edition</h2>
        </div>
        <div className="right">


        </div>
      </header>
      {/* <nav>Nav</nav> */}
      <article>
        <div className="left"></div>
        <div className="center"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            overflow: 'auto',
            height: '100vh'
          }}
        >
          {recipes.map(recipe => (
            // <h3 className="list_elem" onClick={()=>setOpenDialog(true)}><span onClick={() => handleDelRecipe(recipe._id)}> {`Delete - `} </span>  {recipe.name} <span onClick={() => }> - Edit </span> </h3>
            <h3 className="list_elem" onClick={() => {
              setActiveRecipe(recipe)
              setOpenDialog(true)
            }}> {recipe.name} </h3>
          ))}
        </div>
        <div className="right">
        </div>
      </article>
      {/* <aside>Aside</aside> */}
    </>
  )
}